<!--
 * @Descripttion: 
 * @version: 
 * @Author: zhouxh
 * @Date: 2023-05-23 08:20:39
-->
<template>
    <div class="majorproduct-container">
  
      <div class="submenu-wrapper">
        <Submenu 
        :engLabel="englabel"
        :cnLabel="cnLabel"
        :linkData="linkData"
      />
      </div>
  
      <div class="main-wrapper py-2 py-md-5 px-2">


          <!-- 培训照片图 - 3D照片墙-->
          <div class="img-wrapper">
            <p class="split-header">公司会不定期安排各种培训</p>
            <div class="row justify-content-center">
              <div class="col-12 col-xl-12">
                <!-- 3D照片墙组件 -->
                <PhotoWall3D 
                  :photos="trainingPhotos"
                  :auto-rotate="true"
                  :rotation-speed="0.5"
                  :hover-scale="1.2"
                  :spacing="20"
                />
              </div> 
          </div>
        </div>

      </div>


    </div>
  </template>
  
  <script>
  import { JobsLink } from "@/assets/js/submenulink.js";
  import { getProductDetails } from "@/api/product.js";
  import Submenu from "@/components/Submenu/";
  import ImageLoader from "@/components/ImageLoader/";
  import ImagePreview from "@/components/ImagePreview";
  import PhotoWall3D from "@/components/Photo/PhotoWall3D";



  export default {
     components: {
      Submenu,
      ImageLoader,
      ImagePreview,
      PhotoWall3D,
     },
    
     data() {
      return {
        englabel: 'Jobs',
        cnLabel: '培训信息',
        imgHeight: 732,
        img_aspect_ratio: (1351 / 732).toFixed(2),
        windowSize: {},
        linkData: [],

        selectedPhotoIndex: 0,

        // 3D照片墙数据
        trainingPhotos: [
          { 
            id: 1, 
            src: require("@/assets/img/Jobs/train/01.jpg"),
            title: "技术培训",
            description: "专业技术人员培训现场"
          },
          { 
            id: 2, 
            src: require("@/assets/img/Jobs/train/02.jpg"),
            title: "团队建设",
            description: "团队协作能力提升培训"
          },
          { 
            id: 3, 
            src: require("@/assets/img/Jobs/train/03.jpg"),
            title: "安全培训",
            description: "安全生产知识培训"
          },
          { 
            id: 4, 
            src: require("@/assets/img/Jobs/train/04.jpg"),
            title: "质量管理",
            description: "质量管理体系培训"
          },
          { 
            id: 5, 
            src: require("@/assets/img/Jobs/train/05.jpg"),
            title: "创新思维",
            description: "创新思维与方法培训"
          },
          { 
            id: 6, 
            src: require("@/assets/img/Jobs/train/06.jpg"),
            title: "领导力",
            description: "领导力提升培训"
          },
          { 
            id: 7, 
            src: require("@/assets/img/Jobs/train/07.jpg"),
            title: "技能竞赛",
            description: "员工技能竞赛活动"
          },
          { 
            id: 8, 
            src: require("@/assets/img/Jobs/train/08.jpg"),
            title: "知识分享",
            description: "内部知识分享会"
          },
          { 
            id: 9, 
            src: require("@/assets/img/Jobs/train/09.jpg"),
            title: "职业发展",
            description: "职业发展规划培训"
          },
          { 
            id: 10, 
            src: require("@/assets/img/Jobs/train/10.jpg"),
            title: "企业文化",
            description: "企业文化传承培训"
          },
        ],


      }
    },
  
    created() {
        this.getWindowSize();
        this.linkData = JobsLink;
        this.getProductData();
     },
  

    mounted() {
        //拉伸窗口时触发
        window.onresize = () => {
            this.getWindowSize();
            
        }
  
    },
     methods: {
            getProductData() {
              getProductDetails().then(res => {
                    this.ProductData = res;
                  });
            },

            getWindowSize() {
              this.windowSize.width =   document.documentElement.clientWidth || document.body.clientWidth; 
              this.windowSize.Height =  document.documentElement.clientHeight || document.body.clientHeight; 
              this.imgHeight = Math.round(this.windowSize.width / this.img_aspect_ratio); 
            },
            
            getPreviewurl(item){
               return [item];
          },


           selectPhoto(index) {
            this.selectedPhotoIndex = index;
          },
            nextPhoto() {
              this.selectedPhotoIndex = (this.selectedPhotoIndex + 1) % this.photos.length;
            },
            prevPhoto() {
              this.selectedPhotoIndex = (this.selectedPhotoIndex - 1 + this.photos.length) % this.photos.length;
            },
     }
  
  
  }
  </script>
  
  <style scoped lang="less">
  @import "~@/styles/global.less";
  @import "~@/styles/mixin.less";
    .majorproduct-container{
      position: relative;;
      width: 100%;;
      height: auto;
      .general-layout;
  
        .product-details{
          margin:3rem 1rem;
          .product-title{
            text-align: center;
            font-weight: bold;
            margin-bottom: 1rem;
          }

          .product-img{
            width: 100%;
            text-align: center;
            .image-preview-container{
                display: inline-block;
            }
          }

          .details-text span{
            font-weight: 700;
          }
        }
    }


/* 3D照片墙样式已移至PhotoWall3D组件中 */
 
  </style>